import React from "react";

export const Services = (props) => {
  return (
    <>
      <style>{`
        #services {
          overflow-x: hidden;
          width: 100%;
          box-sizing: border-box;
        }
        #services .container {
          width: 100%;
          max-width: 1170px;
          margin: 0 auto;
          padding: 0 15px;
          box-sizing: border-box;
        }
        #services .row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -15px;
          box-sizing: border-box;
        }
        #services .col-md-4 {
          width: 100%;
          padding: 0 15px;
          box-sizing: border-box;
        }
        #services .service-desc p {
          word-wrap: break-word;
          overflow-wrap: break-word;
        }
        #services .service-icon-img {
          width: 120px;
          height: 120px;
          object-fit: contain;
          margin-bottom: 12px;
        }

        @media (min-width: 992px) {
          #services .col-md-4 {
            width: 33.3333%;
          }
        }

        @media (max-width: 767px) {
          #services .col-md-4 {
            width: 100%;
            margin-bottom: 24px;
          }
        }
      `}</style>

      <div id="services" className="text-center">
        <div className="container">
          <div className="section-title">
            <h2>Our Services</h2>
            <p>
              
            </p>
          </div>
          <div className="row">
            {props.data
              ? props.data.map((d, i) => (
                  <div key={`${d.name}-${i}`} className="col-md-4">
                    {/* Cek apakah icon adalah path gambar atau Font Awesome class */}
                    {d.icon && (d.icon.endsWith(".png") || d.icon.endsWith(".jpg") || d.icon.endsWith(".svg") || d.icon.startsWith("img/"))
                      ? <img src={d.icon} alt={d.name} className="service-icon-img" />
                      : <i className={d.icon}></i>
                    }
                    <div className="service-desc">
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                    </div>
                  </div>
                ))
              : "loading"}
          </div>
        </div>
      </div>
    </>
  );
};